module.exports = __webpack_public_path__ + "static/media/12UNCTAD4.56c3a650.jpg";